export const CalendarCheckSmallIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    fill="none"
    viewBox="0 0 25 25"
    {...props}>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.2"
      d="M9.855 2.066v3M17.855 2.066v3M5.355 9.156h17M23.855 19.066c0 .75-.21 1.46-.58 2.06a3.97 3.97 0 01-3.42 1.94c-1.01 0-1.93-.37-2.63-1-.31-.26-.58-.58-.79-.94a3.92 3.92 0 01-.58-2.06c0-2.21 1.79-4 4-4 1.2 0 2.27.53 3 1.36a4 4 0 011 2.64z"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="M18.295 19.066l.99.99 2.13-1.97"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.2"
      d="M22.855 8.566v7.86c-.73-.83-1.8-1.36-3-1.36-2.21 0-4 1.79-4 4 0 .75.21 1.46.58 2.06.21.36.48.68.79.94h-7.37c-3.5 0-5-2-5-5v-8.5c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5z"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="M13.852 13.766h.009M10.15 13.766h.01M10.15 16.766h.01"></path>
  </svg>
);
